import { css, keyframes } from '@emotion/react';

export const fade_in_up_keyframes = keyframes`
  0%{
    transform: translateY(30px);
    opacity: 0;
  }
  100%{
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fade_in_down_keyframes = keyframes`
  0%{
    transform: translateY(-30px);
    opacity: 0;
  }
  100%{
    transform: translateY(0);
    opacity: 1;
  }
`;

export const fade_in_left_keyframes = keyframes`
  0%{
    transform: translateX(30px);
    opacity: 0;
  }
  100%{
    transform: translateX(0);
    opacity: 1;
  }
`;

export const fade_in_right_keyframes = keyframes`
  0%{
    transform: translateX(-30px);
    opacity: 0;
  }
  100%{
    transform: translateX(0);
    opacity: 1;
  }
`;

export const fade_in_scale_keyframes = keyframes`
  0%{
    transform: scale(94%);
    opacity: 0;
  }
  100%{
    transform: scale(100%);
    opacity: 1;
  }
`;

export const fade_in_up = css`
  opacity: 0;
  animation: ${fade_in_up_keyframes} 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

export const fade_in_left = css`
  opacity: 0;
  animation: ${fade_in_left_keyframes} 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

export const fade_in_right = css`
  opacity: 0;
  animation: ${fade_in_right_keyframes} 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

export const fade_in_scale = css`
  opacity: 0;
  animation: ${fade_in_scale_keyframes} 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;

export const fade_in_opacity_top_keyframes = (height: number) => keyframes`
    0% {
      opacity: 0;
      top: ${height - 10}px;
    }
    100% {
      opacity: 1;
      top: ${height}px;
    }
  `;

export const fade_in_opacity_keyframes = (endOpacity: number) => keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: ${endOpacity};
    }
  `;

export const fade_in_fn = (duration: string, opacity: number) => css`
  opacity: 0;
  animation: ${fade_in_opacity_keyframes(opacity)} ${duration} cubic-bezier(0.22, 1, 0.36, 1) forwards;
`;
